import { useQueries } from '@tanstack/react-query'
import { userQueries } from '../../../api/users'
import { IUserModel } from '../../../interfaces/models/users.interfaces'
import { getUserFullName } from '../../../helpers/user'
import { IAttendance } from '../../../interfaces/models/events.interfaces'

export interface UserAttendance {
  user: IUserModel
  status: 'attending' | 'not_attending'
  comment?: string
}

export const useEventUserAttendance = (
  attendants: IAttendance[] | undefined
): { attending: UserAttendance[]; notAttending: UserAttendance[] } => {
  const userAttendancesQuery = useQueries({
    queries:
      attendants?.map((attendant) => {
        return {
          ...userQueries.getUser(attendant.userId),
          select: (user: IUserModel) => {
            return {
              user,
              status: attendant.status,
            }
          },
        }
      }) || [],
  })

  const userAttendances = userAttendancesQuery
    .flatMap((query) => query.data || [])
    .sort((a, b) =>
      getUserFullName(a.user).localeCompare(getUserFullName(b.user))
    )
  const attending = userAttendances.filter(
    (user) => user && user.status === 'attending'
  ) as UserAttendance[]
  const notAttending = userAttendances.filter(
    (user) => user && user.status === 'not_attending'
  ) as UserAttendance[]

  return { attending, notAttending }
}
